import { ValuesOf } from '../services/common/miscUtils.types';

export const pathParams = {
  identStatusId: 'identStatusId',
  identStatusRole: 'identStatusRole',
};

export const dashboardRoutePrefix = '/dashboard';

const createDashboardRoute = (route: string) => {
  return `${dashboardRoutePrefix}/${route}`;
};

export const routes = {
  root: '/',
  error: '/error',
  auth: '/authenticatePage',
  linkexpired: '/linkExpired',
  configurator: '/configuratorBTO',
  form: '/form',
  selectCarType: '/form/1/select-car-type',
  vehicleConfigurationPage: '/form/1',
  selectCustomerType: '/form/2/select-customer-type',
  identLanding: '/identLandingPage',
  identLandingCoApplicant: '/identLandingCoApplicantPage',
  identSuccess: '/identSuccessPage',
  identSuccessCoApplicant: '/identSuccessPagePAWithCoApplicant',
  identSuccessCoApplicantEmail: '/IdentSuccessForCoApplicantEmail',
  identSuccessCoApplicantScrive: '/IdentSuccessForCoApplicantScrive',
  identFailed: '/identFailedPage',
  idenStatus: `/ident-status/:${pathParams.identStatusId}?/:${pathParams.identStatusRole}?`,
  esignStart: '/esign-start',
  esignSuccess: '/esign-success',
  esignRefused: '/esign-refused',
  creditCheckPending: '/CreditCheckPendingPage',
  creditCheckSuccess: '/CreditCheckSuccessPage',
  creditCheckRejection: '/CreditCheckRejectionPage',
  dashboardHome: createDashboardRoute('home'),
  dashboardQuotesActive: createDashboardRoute('active'),
  dashboardQuotes: createDashboardRoute('quotes'),
  dashboardStudies: createDashboardRoute('studies'),
  dashboardAccepted: createDashboardRoute('accepted'),
  dashboardPayment: createDashboardRoute('payment'),
  dashboardCompare: createDashboardRoute('compare'),
  dashboardRun: createDashboardRoute('run'),
  dashboardConversations: createDashboardRoute('conversations'),
  dashboardQuotesDocuments: createDashboardRoute('quotes/:id/documents'),
  dashboardStudiesDocuments: createDashboardRoute('studies/:id/documents'),
  dashboardAcceptedDocuments: createDashboardRoute('accepted/:id/documents'),
  dashboardPaymentDocuments: createDashboardRoute('payment/:id/documents'),
  dashboardRunDocuments: createDashboardRoute('run/:id/documents'),
  dashboardDealerDocuments: createDashboardRoute('dealer-documents'),
  edit: '/edit/',
} as const;

export type TRoutesValues = ValuesOf<typeof routes>;
export type TRoutesKeys = keyof typeof routes;

/**
 * - Routes visited by the end customer related to the esign process.
 * - Those routes are consulted to skip miles token check and dealer companies fetch.
 */
export const esignRoutes = [routes.esignStart, routes.esignSuccess, routes.esignRefused] satisfies Array<TRoutesValues>;

export type TEsignRoutesValues = ValuesOf<typeof esignRoutes>;

export const subpagesRoutes = [
  routes.dashboardQuotes,
  routes.dashboardStudies,
  routes.dashboardAccepted,
  routes.dashboardRun,
  routes.dashboardConversations,
] satisfies Array<TRoutesValues>;

export const identRoutes = [
  '/ident-status',
  routes.identFailed,
  routes.identLanding,
  routes.identLandingCoApplicant,
  routes.identSuccess,
  routes.identSuccessCoApplicant,
  routes.identSuccessCoApplicantEmail,
  routes.identSuccessCoApplicantScrive,
] satisfies Array<TRoutesValues | '/ident-status'>;

export type TIdentRoutesValues = ValuesOf<typeof identRoutes>;

/**
 * - Check if current route point to one of the esign process pages.
 */
export const isEsignRoute = () => {
  return esignRoutes.some((route) => {
    return window.location.pathname.startsWith(route);
  });
};

export const isIdentRoute = () => {
  return identRoutes.some((route) => {
    return window.location.pathname.startsWith(route);
  });
};

export const isErrorRoute = () => {
  return window.location.pathname.startsWith(routes.error);
};

export const isAuthenticationRoute = () => {
  return window.location.pathname.startsWith(routes.auth);
};

export const isDashboardHomeRoute = () => {
  return window.location.pathname.startsWith(routes.dashboardHome);
};

export const isOutletSelectionRoute = () => {
  return window.location.pathname === routes.root;
};

export const isPotentialHybridJourneyRoute = () => {
  return isEsignRoute() || isIdentRoute() || isErrorRoute() || isAuthenticationRoute();
};

export const isAnyDashboardRoute = () => {
  return window.location.pathname.startsWith(dashboardRoutePrefix);
};

export const isDashboardConversationsRoute = () => {
  return window.location.pathname.startsWith(routes.dashboardConversations);
};

/**
 * - Check if route is one of allowed for restoration.
 * - To add route to the list it's views and components need to be prepared
 * and tested to ensure they are in fact restorable.
 */
export const isRouteRestorable = () => {
  return [dashboardRoutePrefix, routes.configurator, `${routes.form}/1`, `${routes.form}/2`, `${routes.form}/3`].some(
    (route) => window.location.pathname.startsWith(route)
  );
};
